module.exports = __webpack_public_path__ + "static/home-0e4db34483e7f00d719ea18f3e942f85.png";